<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 테마 초기화
    this.$store.dispatch('initTheme');
  },
  components: {
  },
};
</script>

<style lang="scss">


  /* 반응형 시작 */
  @media(max-width:750px){
    #app{ width:100%; border-left:0; border-right:0; }
  }

  #app {
    font-family: var(--font-family);
    font-size: var(--font-size-base);
    /* 폰트 스무딩은 html/html.dark 에서 테마별로 지정 (여기서 강제하지 않음) */
    color: rgb(var(--c-content));
    margin:0 auto;
    height:100%;
    overflow:hidden;
  }

  html, body {
    height: 100%;
    margin: 0;
  }

  /* SweetAlert2 아이콘 크기 조정 */
  .swal2-icon {
    width: 4em !important;
    height: 4em !important;
    border-width: .25em !important;
    font-size: 0.6rem !important;
  }
  .swal2-popup{
    font-size : 14px;
  }

  :deep(.swal-icon-animate) {
    animation: swal-bounce 0.4s ease-out;
  }
</style>
